import styled from "styled-components";

export const SdkIframe = styled.iframe`
  border: none;
  height: 100%;
  width: 90%;
`;
